import { render, staticRenderFns } from "./EnterpriseEdit.vue?vue&type=template&id=064bec67"
import script from "./EnterpriseEdit.vue?vue&type=script&lang=js"
export * from "./EnterpriseEdit.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseEdit.vue?vue&type=style&index=0&id=064bec67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports